import React, { useState, useEffect } from 'react';
import './moons.css';

import wcm from '../assets/watercolormoon.png';
import km from '../assets/kissingmoon.png';
import mbh from '../assets/moonbeenhit.png';
import slm from '../assets/stringlightmoon.png';
import inviteJpg from '../assets/huntsharvest.jpg'; // <-- add the actual filename
import starsstars from '../assets/starstsars.png';
import growwings from '../assets/growwings.png';


function Moons() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <div
        className="moons-page"
      >
      <img src={starsstars} alt="starsstars" className="starsstars-image" />
      <img src={growwings} alt="wings" className="wings-image" />


        <div className="moonsie-text">
          <p>Full Moons and Full Moon Parties</p>
        </div>

        <div className="shamrock-text">
          <p>Shamrock</p>
        </div>

        <div className="shamrock2-text">
          <p>Shamrock</p>
        </div>

         <div className="shake-text">
          <p>Shake</p>
        </div>

        <div className="shake2-text">
          <p>Shake</p>
        </div>

         <div className="who-text">
          <p>Who wants to get a</p>
        </div>

        <img src={wcm} alt="wcm" className="wcm-image" />
        <div className="next-moon">Sunday, September 7th</div>

        <img src={km} alt="km" className="km-image" />
        <button
          className="second-moon"
          onClick={() => setOpen(true)}
          aria-haspopup="dialog"
          aria-expanded={open}
        >
          Monday, October 6th
        </button>

        <img src={mbh} alt="mbh" className="mbh-image" />
        <div className="third-moon">Wednesday, November 5th</div>

        <img src={slm} alt="slm" className="slm-image" />
        <div className="fourth-moon">Thursday, December 4th</div>

        {/* Modal */}
        {open && (
          <div className="modal-overlay" role="dialog" aria-modal="true">
            {/* click the dim area to close */}
            <button
              className="overlay-dismiss"
              onClick={() => setOpen(false)}
              aria-label="Dismiss"
            />
            <div className="modal-content">
              <button
                className="close-btn"
                onClick={() => setOpen(false)}
                aria-label="Close invitation"
              >
                ×
              </button>
              <img src={inviteJpg} alt="Invitation" className="invite-image" />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Moons;
